<template>
    <DialogBase class="dialog-settings">

        <template #title>
            Administrator&nbsp;Settings
        </template>

        <template #content>

            <div class="dialog-settings__header">
                <strong>Expert</strong>&nbsp;Mode
            </div>

            <v-switch 
                inset
                hide-details 
                color="color1" 
                label="show expert options that offer greater control" 
                v-model="expertMode">
            </v-switch>

            <br />

            <div class="dialog-settings__header">
                <strong>Debugging</strong>&nbsp;
            </div>

            <v-switch 
                inset
                hide-details 
                color="color1" 
                label="show card states as overlays" 
                v-model="debugCard">
            </v-switch>

            <v-switch 
                inset
                hide-details 
                color="color1" 
                label="show all layers in image card" 
                v-model="debugLayer">
            </v-switch>

        </template>

        <template #actions>
            <v-btn 
                variant="elevated" 
                elevation="2" 
                color="surface"
                @click="handleCancel">
                Cancel
            </v-btn>
            <v-btn 
                variant="elevated" 
                elevation="2" 
                color="color1" 
                @click="handleSave">
                Save
            </v-btn>
        </template>

    </DialogBase>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { DialogBase } from '@generio-ai/library-legacy/components/dialogs'

export default {
    name: 'DialogSettings',
    components: {
        DialogBase
    },
    data() {
        return {
            expertMode: null,
            debugCard: null,
            debugLayer: null
        }
    },
    computed: {
        ...mapGetters('flows', [
            'isExpertMode',
            'isDebugCard',
            'isDebugLayer'
        ])
    },
    methods: {
        ...mapActions('dialogs', [
            'close'
        ]),
        ...mapActions('flows', [
            'setExpertMode',
            'setDebugCard',
            'setDebugLayer'
        ]),
        handleCancel()
        {
            this.close()
        },
        handleSave()
        {
            this.setExpertMode({
                expert: this.expertMode
            })
            this.setDebugCard({
                debug: this.debugCard
            })
            this.setDebugLayer({
                debug: this.debugLayer
            })
            this.close()
        }
    },
    mounted() {
        this.expertMode = this.isExpertMode
        this.debugCard = this.isDebugCard
        this.debugLayer = this.isDebugLayer
        this.generationRandom = this.isGenerationRandom
    }
}
</script>

<style scoped>
.dialog-settings__header {
    width: 100%;
    text-align: left;
    padding: 10px;
    user-select: none;
    font-size: 18px;
}
</style>